import React from 'react';

const Help: React.FC = () => {
  return <div>Help Component</div>;
};

export default Help;
